import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';

import { HpRespModuleContainer } from '../HpRespModuleContainer/HpRespModuleContainer';
import HpRespEditorialModuleItem from './HpRespEditorialModuleItem';
import { trackEditorialImpressions, trackEditorialClick } from './helpers/EditorialTracking';
import { trackModuleLocation } from '../helpers/moduleLocationTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

import { HpRespEditorialModule_componentModule } from './__generated__/HpRespEditorialModule_componentModule.graphql';

type Props = {
    componentModule: HpRespEditorialModule_componentModule;
    useLazyLoadImages: boolean;
    moduleIndex: number;
    totalModules: number;
};

const HpRespEditorialModule: FC<Props> = ({
    componentModule,
    useLazyLoadImages,
    moduleIndex,
    totalModules,
}) => {
    const items = (componentModule?.items || []).filter(filterNulls);

    const handleInitialDisplay = ({ inViewport }: { inViewport: boolean }): void => {
        if (items && inViewport) {
            trackEditorialImpressions(items);
        }
    };

    if (!items) {
        return null;
    }
    return (
        <HpRespModuleContainer addTopGap>
            <SharedInViewport stopWhenInViewport onInViewportChange={handleInitialDisplay}>
                <div className="rowFlex" data-tn="editorial-wrapper">
                    {items.map((item, index) => (
                        <HpRespEditorialModuleItem
                            key={item?.cmsId || index}
                            item={item}
                            index={index}
                            useLazyLoadImages={useLazyLoadImages}
                            onClick={() => {
                                trackEditorialClick(item, index);
                                trackModuleLocation({
                                    label: `content promo module #${index + 1}`,
                                    moduleIndex,
                                    totalModules,
                                });
                            }}
                        />
                    ))}
                </div>
            </SharedInViewport>
        </HpRespModuleContainer>
    );
};

export default createFragmentContainer(HpRespEditorialModule, {
    componentModule: graphql`
        fragment HpRespEditorialModule_componentModule on EditorialModule {
            items {
                cmsId
                linkData {
                    # path is used in EditorialTracking.js
                    path
                }
                ...HpRespEditorialModuleItem_item
            }
        }
    `,
});
